import React from 'react';
import classnames from 'classnames';
import InputWrap from './InputWrap';
import styles from './styles/NativeSelect.module.scss';
import { IFormFieldProps } from './common';

export interface ISelectProps extends IFormFieldProps {
  creatable?: boolean;
  search?: boolean;
  options: any[];
  tooltipPopup?: boolean;
}

const NativeSelect = ({
  children,
  basic,
  label,
  labelAfter,
  description,
  className,
  inputClassName,
  labelClassName,
  leftIcon,
  rightIcon,
  error,
  info,
  options,
  placeholder,
  tooltip,
  onChange,
  scrollIntoView,
  value,
  tooltipPopup,
  ...inputProps
}: ISelectProps) => {
  return (
    <InputWrap
      className={className}
      errorClassName={classnames(styles.error, basic && styles.basicError)}
      error={error}
      label={label}
      labelClassName={labelClassName}
      name={inputProps.name}
      rightIcon={rightIcon}
      scrollIntoView={scrollIntoView}
      tooltipPopup={tooltipPopup}
    >
      <div className={styles.nSelectInputContainer}>
        <select
          name={inputProps.name}
          id={inputProps.name}
          className={styles.nativeSelect}
          onChange={onChange}
          value={value || ''}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </div>

      {children}
    </InputWrap>
  );
};

export default NativeSelect;
